function iconHelp() {
  const icon = document.querySelector('.help-icon');
  if (!icon) {
    return;
  }
  const text = icon.querySelector('.help-icon__text');

  function startAnimation() {
    // Сбрасываем анимацию
    text.style.animation = 'none';

    setTimeout(() => {
      text.style.animation = 'scaleAndFade 10.7s infinite';
    }, 1000);
  }

  // startAnimation();
}

export { iconHelp }

